import { Pipe, PipeTransform } from '@angular/core';
import { Genders } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'genderDisplay',
})
export class GenderDisplayPipe implements PipeTransform {
  transform(value: Genders): string {
    return CoreNiceLabelUtils.gender(value);
  }
}
